import { Component, computed, input, output, viewChildren } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { ICampaignCreatorForm } from '@campaign-form/campaign-form.interface';
import { TranslateModule } from '@ngx-translate/core';
import { EDeliverableFlowStep } from '@pages/campaigns/campaign-form/form-fields/creators-and-ctas/deliverable-flow-dialog/deliverable-flow-dialog.interface';
import { IBriefingNote, TCampaignApi } from '@pages/campaigns/campaigns.interface';
import { IconBadgeComponent } from '@shared/components/icon-badge/icon-badge.component';
import { IconComponent } from '@shared/components/icon/icon.component';
import { CreatorSummaryPanelComponent } from '../creator-summary-panel/creator-summary-panel.component';

@Component({
  imports: [CreatorSummaryPanelComponent, IconBadgeComponent, IconComponent, MatButtonModule, TranslateModule],
  selector: 'app-campaign-form-creators-list',
  templateUrl: './campaign-form-creators-list.component.html',
})
export class CampaignFormCreatorsListComponent {
  public readonly campaignCreatorsValue = input.required<FormGroup<ICampaignCreatorForm>['value'][]>();
  public readonly campaign = input.required<TCampaignApi | null>();
  public readonly ctasShareCountMap = input.required<Map<string, number>>();
  public readonly creatorHasCustomValueMap = input.required<Map<string, boolean>>();
  public readonly getExistingDeliverablesCount = input.required<(ctaId: string, creatorId: string) => number>();
  public readonly getExistingExecutionsCount = input.required<(ctaId: string, creatorId: string) => number | null>();
  public readonly getExistingKpisCount = input.required<(ctaId: string, creatorId: string) => number>();
  public readonly briefingNotes = input<IBriefingNote[]>([]);
  public readonly newlyAddedCreatorIds = input<string[]>([]);

  public readonly addCreatorClick = output<void>();
  public readonly editPayoutClick = output<string>();
  public readonly deleteCreatorClick = output<string>();
  public readonly briefingNoteClick = output<string>();
  public readonly addIndividualGroupClick = output<string>();
  public readonly addDeliverablesForCta = output<{ creatorId: string; ctaId: string; step: EDeliverableFlowStep }>();
  public readonly editCtaName = output<{ creatorId: string; ctaId: string }>();
  public readonly editCtaGroup = output<{ creatorId: string; ctaId: string }>();
  public readonly removeCtaFromCreator = output<{ creatorId: string; ctaId: string; isAllCreators: boolean }>();
  public readonly copyCtaForCreator = output<{ ctaId: string; creatorId: string }>();
  public readonly copyCta = output<string>();

  public readonly creatorsCount = computed(() => this.campaignCreatorsValue().length);
  public readonly allExpanded = computed(() => {
    const panels = this.creatorPanels();

    return panels.length > 0 && panels.every((p) => p.isExpanded());
  });
  public readonly creatorBriefingNoteMap = computed(() => {
    const map = new Map<string, boolean>();

    this.briefingNotes().forEach((n) => {
      if (n.creatorId) {
        map.set(n.creatorId, !!n.note?.trim() || !!n.files?.length);
      }
    });

    return map;
  });

  private readonly creatorPanels = viewChildren(CreatorSummaryPanelComponent);

  public expandCollapseAll(): void {
    const shouldExpand = !this.allExpanded();

    this.creatorPanels().forEach((p) => (shouldExpand ? p.expansionPanel().open() : p.expansionPanel().close()));
  }
}
